import * as moment from 'moment';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var Reglamento_copropiedadComponent = /** @class */ (function () {
    function Reglamento_copropiedadComponent(_formService, fb) {
        this._formService = _formService;
        this.fb = fb;
        this.rows = [];
        this.matcher = new FormService();
        this.maxDate = moment().toDate();
        this.form = new FormGroup({
            notaria_reg_copro: new FormControl(''),
            fecha_notaria: new FormControl({ value: '', disabled: true }),
            cbr_reg_copro: new FormControl(''),
            registro_anio: new FormControl(''),
            fojas_reg_copro: new FormControl(''),
            numero: new FormControl(''),
        });
        if (!JSON.parse(localStorage.getItem("reglamento_copropiedad"))) {
            localStorage.setItem("reglamento_copropiedad", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("reglamento_copropiedad"));
            this.form.controls['notaria_reg_copro'].setValue(this.rows[0] ? this.rows[0].notaria_reg_copro : false);
            this.form.controls['fecha_notaria'].setValue(this.rows[0] ? new Date(this.rows[0].fecha_notaria) : null);
            this.form.controls['cbr_reg_copro'].setValue(this.rows[0] ? this.rows[0].cbr_reg_copro : '');
            this.form.controls['registro_anio'].setValue(this.rows[0] ? this.rows[0].registro_anio : '');
            this.form.controls['fojas_reg_copro'].setValue(this.rows[0] ? this.rows[0].fojas_reg_copro : '');
            this.form.controls['numero'].setValue(this.rows[0] ? this.rows[0].numero : '');
        }
    }
    Reglamento_copropiedadComponent.prototype.add_reglamento_copropiedad = function (event, type) {
        if (event) {
            if (type == 'change' || type == 'input') {
                this.fech_reglamento_copropiedad = moment(event.value).format('DD/MM/YYYY');
            }
        }
        else {
            var temp = JSON.parse(localStorage.getItem("reglamento_copropiedad"));
            if (temp > 0) {
                this.fech_reglamento_copropiedad = temp[0].fech_reglamento_copropiedad;
            }
        }
        localStorage.setItem("reglamento_copropiedad", JSON.stringify([]));
        this.actualRow = localStorage.getItem("reglamento_copropiedad");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            notaria_reg_copro: this.form.value.notaria_reg_copro,
            fecha_notaria: this.fech_reglamento_copropiedad,
            cbr_reg_copro: this.form.value.cbr_reg_copro,
            registro_anio: this.form.value.registro_anio,
            fojas_reg_copro: this.form.value.fojas_reg_copro,
            numero: this.form.value.numero,
        });
        localStorage.setItem("reglamento_copropiedad", JSON.stringify(this.rows));
        console.log(this.reglamento_copropiedad);
    };
    Reglamento_copropiedadComponent.prototype.delete_reglamento_copropiedad = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("reglamento_copropiedad", JSON.stringify(this.rows));
            }
        }
    };
    return Reglamento_copropiedadComponent;
}());
export { Reglamento_copropiedadComponent };
